import { render, staticRenderFns } from "./CreateGettingStarted.vue?vue&type=template&id=32e8efe2&scoped=true"
import script from "./CreateGettingStarted.vue?vue&type=script&lang=js"
export * from "./CreateGettingStarted.vue?vue&type=script&lang=js"
import style0 from "./CreateGettingStarted.vue?vue&type=style&index=0&id=32e8efe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e8efe2",
  null
  
)

export default component.exports